import { L10n } from '../L10n/L10n';
import { IWorkbookBase, IWorkbookInfo } from '../models/IWorkbookInfo';
import { Set } from '../models/Set';
import { Module } from '../Module';
import {
  CreateExtractTasksAction,
  ICreateExtractTasksScope,
  IExtractTaskSchedule,
} from '../services/CreateExtractTasksAction';

interface CreateWorkbookExtractRefreshScope extends ICreateExtractTasksScope {
  workbook: IWorkbookBase;
  allowedMode: string;
  extractTask: IExtractTaskSchedule;
}

Module.instance().directive('tbWorkbookExtractRefreshScheduler',
  [ '$translate',
    'CreateExtractTasksAction',

    ($translate: ng.translate.ITranslateService,
     CreateExtractTasksAction: CreateExtractTasksAction) => {
      return {
        restrict: 'E',
        scope: {
          workbook: '=',
          allowedMode: '@',
          extractTask: '='
        },
        templateUrl: 'confirmActionDialogExtractRefresh.html',
        link: (scope: CreateWorkbookExtractRefreshScope) => {
          const scheduleOnServerPrompt = $translate.instant('schedulesLabelPromptWorkbook', { WORKBOOK_NAME: L10n.elideIfLong(scope.workbook.name) });
          const scheduleOnClientPrompt = ''; // Not applicable for workbooks

          const refreshNowPrompt =
            $translate.instant('extractTasksRefreshNowOnWorkbooksPrompt', {
              WORKBOOK_COUNT: 1,
              WORKBOOK_NAME: L10n.elideIfLong(scope.workbook.name)
            }, L10n.Interpolations.Count);

          const workbookSet = Set.singleton(scope.workbook, (wb: IWorkbookInfo) => wb.id);

          CreateExtractTasksAction.populateScope(scope, workbookSet, scheduleOnServerPrompt, scheduleOnClientPrompt, parseInt(scope.allowedMode, 10), refreshNowPrompt);
        }
      };
    }
  ]
);
